<mat-expansion-panel class="panel">
  <mat-expansion-panel-header>
    <mat-panel-title>{{ 'ASSOCIATIONS.CAMPAIGNS.TITLE' | translate }}</mat-panel-title>
  </mat-expansion-panel-header>
  <p class="association-card-text">
    {{ 'ASSOCIATIONS.CAMPAIGNS.COMPANY_CARD.BODY_ONE' | translate }}
    <span class="association-card-text-bold"
      >{{ 'ASSOCIATIONS.CAMPAIGNS.COMPANY_CARD.CONTACTS_TAB' | translate }},</span
    >
    {{ 'ASSOCIATIONS.CAMPAIGNS.COMPANY_CARD.BODY_TWO' | translate }}
    <span class="association-card-text-bold"
      >{{ 'ASSOCIATIONS.CAMPAIGNS.COMPANY_CARD.CONTACTS_TABLE' | translate }}.</span
    >
  </p>
</mat-expansion-panel>
